module.exports = __webpack_public_path__ + "media/images/lamellenvorhaenge-3b41ddd3c092d549402ec273c23a8603.jpg";